import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { ONBOARDING_FLOWS } from './onboarding';
import { REWARD_CENTER_ONBOARDING_STEPS } from '../components/OnboardingLayer/onboardingSteps';
import QueryParamsProxy from './queryParamProxy';
import RouteParamConstants from './routeParamConstants';
import store from '../state/store';
import Screens from '../screens';
import ENVIRONMENT_VARIABLES from '../utils/environmentVariables';
import { postRewardCenter } from '../state/query/rewardCenter';
import { postOTPSendEmail } from '../state/query/oneTimePassword';
import { ServerResponseKeys } from '../api/Constants';
export default {
  showModal: function () {
    var _showModal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(modalType) {
      var redeemVipAccess,
          state,
          onboardingsSeen,
          onboardingStep,
          isAccountLinked,
          hasSeenOnboarding,
          initRewardRequest,
          timeout,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              redeemVipAccess = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
              state = store.getState();
              onboardingsSeen = state.ftue.onboardingsSeen[state.playerInfo.playerId] || [];
              onboardingStep = state.currentOnboarding.currentStep;
              isAccountLinked = state.playerInfo.isAccountLinked;
              hasSeenOnboarding = onboardingsSeen.includes(ONBOARDING_FLOWS.REWARD_CENTER) && onboardingStep === REWARD_CENTER_ONBOARDING_STEPS.SECOND_VISIT && isAccountLinked === 'no';
              _context2.next = 8;
              return store.dispatch(postRewardCenter.initiate()).unwrap();

            case 8:
              initRewardRequest = _context2.sent;
              timeout = 0;

              if (!initRewardRequest[0].otpExpired) {
                _context2.next = 14;
                break;
              }

              timeout = 500;
              _context2.next = 14;
              return store.dispatch(postOTPSendEmail.initiate()).unwrap().then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
                  var _QueryParamsProxy$set;

                  var otpAuthTransaction, otpPromise;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          otpAuthTransaction = _ref[ServerResponseKeys.CALL_RESPONSE].otpAuthTransaction;
                          otpPromise = QueryParamsProxy.setQueryParamsWithModalPromise((_QueryParamsProxy$set = {}, _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_MODAL, Screens.OneTimePassword), _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_OTP_TRANSACTION_ID, otpAuthTransaction === null || otpAuthTransaction === void 0 ? void 0 : otpAuthTransaction.transactionId), _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_OTP_USER_ID, otpAuthTransaction === null || otpAuthTransaction === void 0 ? void 0 : otpAuthTransaction.userId), _QueryParamsProxy$set));
                          _context.next = 4;
                          return otpPromise;

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }()).catch(function () {
                return null;
              });

            case 14:
              setTimeout(function () {
                if (modalType === Screens.RewardCenter && hasSeenOnboarding && ENVIRONMENT_VARIABLES.LINKING_CARD_POPUP_ON_HIT_REWARD_CENTER !== 'false') {
                  QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.LinkCardOnboarding));
                } else if (modalType === Screens.RewardCenter && !onboardingsSeen.includes(ONBOARDING_FLOWS.REWARD_CENTER)) {
                  QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.RewardCenterOnboarding));
                } else if (redeemVipAccess) {
                  var _QueryParamsProxy$set4;

                  QueryParamsProxy.setQueryParams((_QueryParamsProxy$set4 = {}, _defineProperty(_QueryParamsProxy$set4, RouteParamConstants.PARAM_MODAL, Screens.RewardCenter), _defineProperty(_QueryParamsProxy$set4, RouteParamConstants.PARAM_RC_CATEGORY, 4), _QueryParamsProxy$set4));
                } else {
                  QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, modalType));
                }
              }, timeout);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function showModal(_x) {
      return _showModal.apply(this, arguments);
    }

    return showModal;
  }()
};